import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`டாட்டில் என்றால் என்ன?`}</h1>
    <h3><a parentName="h3" {...{
        "href": "/faq"
      }}>{`English`}</a>{` | `}<a parentName="h3" {...{
        "href": "/lang/marathi/faq_marathi"
      }}>{`मराठी`}</a>{` | `}<a parentName="h3" {...{
        "href": "/lang/telugu/faq_telugu"
      }}>{`తెలుగు`}</a>{` | `}<a parentName="h3" {...{
        "href": "/lang/tamil/faq_tamil"
      }}>{`தமிழ்`}</a></h3>
    <p>{`டாட்டில் இந்தியாவை மையமாகக்கொண்டு இயங்கும் ஒரு தொழில்நுட்ப நிறுவனமாகும். செய்திப் பரிமாற்றத்திற்காகப் பெரும்பாலும் தொலைபேசிகளைச் சார்ந்திருக்கும் மக்களுக்கு, அவர்களின் மொழிகளில் சரிபார்க்கப்பட்ட தகவல்கள் எளிமையான முறையில் கிடைக்க பணியாற்றி வருகிறோம். தொடக்க காலத்தில், வாட்சப் செயலியில் இருக்கும் தவறான செய்திகளை மட்டும் ஆராய்ந்துகொண்டிருந்தோம். இப்போது, உரையாடல்களுக்காக வடிவமைக்கப்படும் அனைத்துச் செயலிகளிலும், மறையாக்க வலையமைப்புகளிலும் (encrypted networks) தவறான செய்திகள் எவ்வாறு பரப்பபடுகின்றன என்பதனை ஆராய்கிறோம்.
டாட்டிலின் குறிக்கோள்கள்கள் என்னென்ன?
நீண்டகாலக் குறிக்கோள்களாக நாங்கள் வரையறுத்திருப்பது :`}</p>
    <ul>
      <li parentName="ul">{`வாட்சப் மற்றும் இதர செய்திப் பரிமாற்ற செயலிகளில் தவறான செய்திகளின் சுழற்சியைக் குறைத்தல்`}</li>
      <li parentName="ul">{`சமூக வலைத்தளங்களில், குறிப்பாக, தனிப்பட்ட மற்றும் மறையாக்க வலையமைப்புகளில் தவறான செய்திப் பரிமாற்றங்கள் நிகழ்வது குறித்த வெளிப்படையான ஆராய்ச்சிகளை ஊக்குவித்தல்`}</li>
    </ul>
    <h2>{`டாட்டில் தனது சாதனைகளின் அளவுகோல்களை எவ்வாறு நிர்ணயித்திருக்கிறது?`}</h2>
    <ul>
      <li parentName="ul">{`நாங்கள் தகவல்கள் சரிபார்க்க, அதுகுறித்து ஆராய்ச்சி செய்ய திறமூல (open source) கருவிகளை உருவாக்கி வருகிறோம். இக்கருவிகளின் செயல்திறன், எங்கள் மதிப்பீடுகளைவிட அதிகமாகும்போது;`}</li>
      <li parentName="ul">{`இக்கருவிகளை, மக்களும், தகவல் சரிபார்க்கும் குழுக்களும் அதிக அளவில் பயன்படுத்தும்போது;`}</li>
      <li parentName="ul">{`சமூக வலைதளங்களில் தவறான செய்திகள் / வதந்திகள் பரப்பப்படும்போது, அதுகுறித்த புரிதலுடன் மக்கள் இயங்கும்போது;
நாங்கள் சரியான திசையில் பயணிக்கிறோம் என்று அறிந்துகொள்ளலாம்.`}</li>
    </ul>
    <h2>{`டாட்டிலின் விழுமியங்கள் என்னென்ன?`}</h2>
    <ul>
      <li parentName="ul">{`வெளிப்படைத்தன்மை`}</li>
      <li parentName="ul">{`அனைவருக்குமான அணுகுமுறை`}</li>
      <li parentName="ul">{`நிலையாக நீடித்தல்`}</li>
      <li parentName="ul">{`பணிவுடன் இயங்குதல்`}</li>
      <li parentName="ul">{`ஆர்வமுடைமை`}</li>
    </ul>
    <p>{`டாட்டிளின் விழுமியங்கள் குறித்து இங்கே மேலும் அறிந்துகொள்ளலாம்.`}</p>
    <h2>{`டாட்டிலின் ஆக்கங்கள் எவ்வகையான உரிமங்களின் கீழ் பதிவு செய்யப்பட்டுள்ளது?`}</h2>
    <p>{`டாட்டிலின் Code-க்கான உரிமம் `}<a parentName="p" {...{
        "href": "https://www.gnu.org/licenses/gpl-3.0.en.html"
      }}>{`GPL`}</a>{`-ன் கீழும், Data-க்கான உரிமம் `}<a parentName="p" {...{
        "href": "https://opendatacommons.org/licenses/odbl/"
      }}>{`ODbl`}</a>{`-ன் கீழும் பதியப்பட்டுள்ளது.`}</p>
    <h2>{`டாட்டிலின் நிறுவன கட்டமைப்பு எப்படிப்பட்டது ?`}</h2>
    <p>{`டாட்டில் இந்தியாவில் தன்னை ஒரு தனியார் நிறுவனமாகப் பதிவுசெய்துகொண்டுள்ளது. நிறுவன மேலாண்மையில் வெளிப்புறத்திலிருந்து எவ்வித தலையீடும், அழுத்தமும் இருக்ககூடாது என்பதற்காகவே தனியார் நிறுவனமாகப் பதிவு செய்துகொண்டோம். `}<a parentName="p" {...{
        "href": "https://aiethicsinitiative.org/news/2019/3/12/announcing-the-winners-of-the-ai-and-the-news-open-challenge"
      }}>{`AI Ethics Initiative`}</a>{` எங்களுக்கு நிதியுதவி அளித்துள்ளது.
இச்செயல்திட்டத்தில் தொடக்ககாலத்திலிருந்து டென்னியும் தருணிமாவும் பங்காற்றி பராமரித்து வருகிறார்கள். இதுவரை எங்களுக்கு தன்னார்வலர்கள், குறுகிய கால பணியாளர்கள், மற்றும் திறமூல பங்கேற்பாளர்கள் மூலமாக உதவிகள் கிடைத்தன. இச்செயல்திட்டத்தில் மேலும் பல மக்களை இணைத்துப் பங்காற்ற வைப்பதே எங்கள் விருப்பம்.`}</p>
    <h2>{`நான் டாட்டிலில் எவ்வாறு பங்காற்றலாம்?`}</h2>
    <p>{`உங்களுக்கு விருப்பமான எந்த வழியில் வேண்டுமானாலும் எங்களுக்கு நீங்கள் உதவி புரியலாம். ஒரு கலைஞராக, கதைசொல்லியாக, பொறியாளராக, ஆசிரியராக, தகவல்கள் சரிபார்ப்பவராக, ஒரு பொறுப்பான குடிமகனாக – ஆன்லைன் உரையாடல்கள் மேம்பட உங்களால் எவ்வித உதவி செய்யமுடிந்தாலும் நாங்கள் அதனை மனமுவந்து ஏற்றுக்கொள்கிறோம். எங்களுடன் இணைந்து பணியாற்ற விரும்பினால் தொடர்புகொள்வதற்கான பக்கத்தை அணுகவும்.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      